import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import axios from 'config/axios';
import { ReactQueryKeys } from 'config/constant';
import {
  fetchStoreDetailsSuccess,
  fetchStoreDetailsFailure,
} from 'redux/actions/store';
import { useApiDefaults } from './useApiDefaults';
import { refetchOnWindowFocus } from 'config/reactQuery';

export function useStoreDetails(enabled = true) {
  const dispatch = useDispatch();
  const apiDefaults = useApiDefaults();

  const fetchData = async () => {
    try {
      const response = await axios.post('/AogGetStoreDetail', apiDefaults);
      dispatch(fetchStoreDetailsSuccess(response.data.data));
      return response.data.data;
    } catch (error) {
      dispatch(
        fetchStoreDetailsFailure({ error: error.data?.message })
      );
      throw error;
    }
  };

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: [ReactQueryKeys.STORE_DETAILS, apiDefaults],
    queryFn: fetchData,
    enabled: !!apiDefaults && enabled,
    refetchOnWindowFocus,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
}
